import { useScales } from '@Contexts/scales';
import { SelectOption } from '@synqo/frontend-component-library';
import { EnumUnit, getShortUnitLabel } from '@Model';

import { useMemo, useCallback } from 'react';

export function useScaleSelection(allowedUnit: EnumUnit | undefined) {
    const { selectScale, selectedScale, availableScales, canUseAutomaticWeighing } = useScales();

    const selectableScales = useMemo(
        () => availableScales.filter((s) => allowedUnit === undefined || s.unit === allowedUnit),
        [availableScales, allowedUnit],
    );

    const setSelectedScale = useCallback(
        (scaleId: string) => {
            const newSelectedScale = selectableScales.find((scale) => scale.id === scaleId);
            if (newSelectedScale === undefined) {
                return false;
            }

            selectScale(newSelectedScale);

            return true;
        },
        [selectableScales, selectScale],
    );

    const scalesOptions: SelectOption<string>[] = useMemo(
        () =>
            selectableScales.map((s) => {
                return {
                    name: s.id,
                    label: s.label,
                    value: s.id,
                };
            }),
        [selectableScales],
    );

    const dominantUnit = allowedUnit ?? selectedScale?.unit ?? EnumUnit.Ton;
    const weightUnit = getShortUnitLabel(dominantUnit);

    const hasMultipleScales = scalesOptions.length > 1;

    return {
        dominantUnit,
        weightUnit,

        selectedScale,
        scalesOptions,
        setSelectedScale,
        canUseAutomaticWeighing,
        hasMultipleScales,
    };
}
